import CabinetShell from '../../features/cabinet/CabinetShell';
import { QUALITY_MANAGER_CABINET } from '../../features/cabinet/configs';

export default function QualityManagerPage() {
  return <CabinetShell config={QUALITY_MANAGER_CABINET} />;
}
